/**
 * Product delivery block: cutoff time only.
 * Before cutoff (weekday) = "Wysyłka Dzisiaj", countdown, odbiór = następny dzień roboczy.
 * After cutoff or weekend = "Wysyłka od jutra", odbiór = za 2 dni robocze.
 * Dni z metafielda shop custom.swieta (lista dat) są pomijane jak weekendy.
 * Nazwy miesięcy pobierane automatycznie z Intl.DateTimeFormat wg języka sklepu.
 * Kraj i język pobierane z Shopify Markets (selektor kraju/języka w nagłówku).
 */
(function () {
  function dateToKey(date) {
    var y = date.getFullYear();
    var m = (date.getMonth() + 1);
    var d = date.getDate();
    return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
  }

  function isWeekend(date) {
    var d = date.getDay();
    return d === 0 || d === 6;
  }

  function isHoliday(date, holidaysSet) {
    if (!holidaysSet || holidaysSet.size === 0) return false;
    return holidaysSet.has(dateToKey(date));
  }

  function isWorkDay(date, holidaysSet) {
    return !isWeekend(date) && !isHoliday(date, holidaysSet);
  }

  function addBusinessDays(date, n, holidaysSet) {
    if (n <= 0) return new Date(date.getTime());
    var result = new Date(date.getTime());
    while (n > 0) {
      result.setDate(result.getDate() + 1);
      if (isWorkDay(result, holidaysSet)) n--;
    }
    return result;
  }

  function formatDate(date, locale) {
    try {
      return new Intl.DateTimeFormat(locale || 'pl', { day: 'numeric', month: 'short' }).format(date);
    } catch (e) {
      return date.getDate() + '.' + (date.getMonth() + 1) + '.';
    }
  }

  function parseHolidays(holidaysAttr) {
    var set = new Set();
    if (!holidaysAttr || typeof holidaysAttr !== 'string') return set;
    holidaysAttr.split(',').forEach(function (s) {
      var t = s.trim();
      if (t) set.add(t);
    });
    return set;
  }

  function getCountryFromUrl() {
    var match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i);
    return match ? match[1].toLowerCase() : null;
  }

  function updateBlock(block) {
    var cutoffHour = parseInt(block.getAttribute('data-cutoff-hour'), 10) || 14;
    var cutoffMinute = parseInt(block.getAttribute('data-cutoff-minute'), 10) || 0;
    var titleToday = block.getAttribute('data-title-today') || 'Wysyłka Dzisiaj';
    var titleTomorrow = block.getAttribute('data-title-tomorrow') || 'Wysyłka od jutra';
    var holidaysSet = parseHolidays(block.getAttribute('data-holidays'));
    // URL subfolder (/ro, /de, /sk…) ma pierwszeństwo nad Shopify Markets
    var countryCode = getCountryFromUrl() || (block.getAttribute('data-country-code') || '').toLowerCase();
    var locale = block.getAttribute('data-locale') || 'pl';
    var globalDays = parseInt(block.getAttribute('data-global-days'), 10);
    if (isNaN(globalDays)) globalDays = 1;

    var baseDays = globalDays;
    if (countryCode) {
      var specificDays = block.getAttribute('data-transit-' + countryCode);
      console.log('[delivery] countryCode:', countryCode, '| data-transit-' + countryCode + ':', JSON.stringify(specificDays), '| globalDays:', globalDays);
      if (specificDays !== null && specificDays !== '') {
        var parsedDays = parseInt(specificDays, 10);
        if (!isNaN(parsedDays)) {
          baseDays = parsedDays;
        }
      }
    }
    console.log('[delivery] baseDays final:', baseDays, '| locale:', locale, '| data-country-code attr:', block.getAttribute('data-country-code'));
    if (baseDays < 0) baseDays = 0;

    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var cutoffToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, cutoffMinute, 0);

    var titleEl = block.querySelector('.product-delivery__title');
    var countdownWrap = block.querySelector('.product-delivery__countdown-wrap');
    var countdownEl = block.querySelector('.product-delivery__countdown');
    var dateEl = block.querySelector('.product-delivery__date');

    var beforeCutoff = now < cutoffToday && isWorkDay(now, holidaysSet);

    if (beforeCutoff) {
      if (titleEl) titleEl.textContent = titleToday;
      if (countdownWrap) countdownWrap.style.display = '';
      var diffMs = cutoffToday - now;
      var h = Math.floor(diffMs / (1000 * 60 * 60));
      var m = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      if (countdownEl) countdownEl.textContent = (h > 0 ? h + 'h ' : '') + (m > 0 ? m + 'm' : (h > 0 ? '' : '0m'));
      if (dateEl) dateEl.textContent = formatDate(addBusinessDays(today, baseDays, holidaysSet), locale);
    } else {
      if (titleEl) titleEl.textContent = titleTomorrow;
      if (countdownWrap) countdownWrap.style.display = 'none';
      if (countdownEl) countdownEl.textContent = '';
      if (dateEl) dateEl.textContent = formatDate(addBusinessDays(today, baseDays + 1, holidaysSet), locale);
    }
  }

  function init() {
    document.querySelectorAll('.product-delivery[data-cutoff-hour]').forEach(updateBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
